import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash"
import { summaryTableColumns, resultTableColumns} from "./tableColumns";
import { TableStyle } from './tableStyle';

/**
 * Body component for downtime by rig comparison.
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const DowntimeByRigComparisonBody = (prop) => {
    const {filters, data} = prop;

    if (!filters.isSubmitted) {
        return null;
    }

    if (isEmpty(data.result_table)) {
        return <MessageEmptyData/>;
    }

    const summaryColumns = ['rig_data'].concat(data.result_table[0].rigs.map(item => item.name));
    const resultColumns = ['description'].concat(data.result_table[0].rigs.map(item => item.name));

    const getTableBody = (dataAccessor, columns) => {
        return data[dataAccessor].map(rowData => {
            return columns.reduce((prevColumn, currColumn) => {
                if (currColumn !== 'description' && currColumn !== 'rig_data') {
                    return ({ ...prevColumn, [currColumn]: rowData.rigs.filter(item => item.name === currColumn)[0].value});
                }

                return (
                    { 
                        ...prevColumn,
                        [currColumn]: rowData.description,
                    }
                );
            }, {});
        });
    }

    return (
        <div className="container-fluid overflow-auto">
            <TableStyle>
                <TableReport
                    columns={summaryTableColumns(summaryColumns)}
                    data={getTableBody('summary_table', summaryColumns)}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    getExportFileName={() => 'downtime_by_rig_comparison_summary'}
                    scrollable={false}
                    lastRowsToExcludeFromSort={true}
                />
            </TableStyle>
            <TableStyle>
                <TableReport
                    columns={resultTableColumns(resultColumns)}
                    data={getTableBody('result_table', resultColumns)}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    getExportFileName={() => 'downtime_by_rig_comparison_result'}
                    scrollable={false}
                    lastRowsToExcludeFromSort={true}
                />
            </TableStyle>
        </div>
    );
}

export default DowntimeByRigComparisonBody;
